import React from "react"

export default function CurveRound(props) {
  return (
    <svg
      viewBox="0 0 64 582"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0_12_375)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.624-50H738v649H47.681C18.384 524.333 0 404.756 0 265.871 0 143.643 14.239 30.505 37.624-50z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_12_375">
          <path fill="none" d="M0 0h64v582H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
